<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-option`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.214 6.979l17.91 31.02L45 38a1 1 0 011 1v2a1 1 0 01-1 1H34a2 2 0 01-.469-.055 2 2 0 01-2.281-.923L13.338 9.999 3 10a1 1 0 01-1-1V7a1 1 0 011-1h11c.052 0 .104.002.155.006a2 2 0 012.06.973zM41 6a1 1 0 011 1v2a1 1 0 01-1 1H29a1 1 0 01-1-1V7a1 1 0 011-1h12z"/></svg>
</template>
<script>

export default {
  name: 'IconOption',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
